import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-courses-details-style-one',
  templateUrl: './courses-details-style-one.component.html',
  styleUrls: ['./courses-details-style-one.component.scss']
})
export class CoursesDetailsStyleOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
